var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-md col-lg-8 col-md-8"},[_c('AddCustomer',{on:{"submit":_vm.registerCustomer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }